import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-molecule-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() noPadding: boolean = false;
  @Input() noShadow: boolean = false;
  @Input() bordered: boolean = false;
  @Input() additionalClasses: string = '';
  @Input() headerClasses: string = '';
  @Input() bodyClasses: string = '';
  @Input() footerClasses: string = '';
  @Input() hasFooterContent: boolean = false;

  get cardClasses(): string {
    const classes = ['bg-white', 'rounded-lg', 'overflow-hidden'];

    if (!this.noShadow) {
      classes.push('shadow-md', 'hover:shadow-lg', 'transition-shadow', 'duration-200');
    }

    if (this.bordered) {
      classes.push('border', 'border-gray-200');
    }

    if (this.additionalClasses) {
      classes.push(this.additionalClasses);
    }

    return classes.join(' ');
  }

  get defaultHeaderClasses(): string {
    const classes = ['border-b', 'border-gray-200', 'px-6', 'py-4'];
    if (this.headerClasses) {
      classes.push(this.headerClasses);
    }
    return classes.join(' ');
  }

  get defaultBodyClasses(): string {
    const classes = [];
    if (!this.noPadding) {
      classes.push('p-6');
    }
    if (this.bodyClasses) {
      classes.push(this.bodyClasses);
    }
    return classes.join(' ');
  }

  get defaultFooterClasses(): string {
    const classes = ['border-t', 'border-gray-200', 'px-6', 'py-4', 'bg-gray-50'];
    if (this.footerClasses) {
      classes.push(this.footerClasses);
    }
    return classes.join(' ');
  }
}
